import React from "react";

import {
  StyledBlueBox,
  FormBox,
  StyledFormFieldBox,
  LogoBox,
  StyledSeparator,
  StyledPartnerLogo,
  StyledShyftLogo,
  Title,
  Subtitle,
} from "./style";

const FormWrapper = ({ showLogo, partnerLogo, title, subtitle, children }) => {
  const PartnerLogo = (
    <>
      {partnerLogo && <StyledPartnerLogo src={partnerLogo} />}
      {partnerLogo && <StyledSeparator />}
    </>
  );

  const ShyftLogo = <StyledShyftLogo icon="icon-shyft-logo-plain" />;

  const Logo = showLogo && (
    <LogoBox mb="8px">
      {PartnerLogo}
      {ShyftLogo}
    </LogoBox>
  );

  const FormTitle = <Title variant="heading6">{title}</Title>;

  const FormSubtitle = <Subtitle variant="paragraph3">{subtitle}</Subtitle>;

  const BlueBox = (
    <StyledBlueBox flexDirection="column">
      {Logo}
      {FormTitle}
      {FormSubtitle}
    </StyledBlueBox>
  );

  const FormFieldBox = <StyledFormFieldBox>{children}</StyledFormFieldBox>;

  return (
    <FormBox>
      {BlueBox}
      {FormFieldBox}
    </FormBox>
  );
};

export default FormWrapper;
